/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useState, useEffect } from "react";
import loadingIcon from "../../../../../../assets/icons/loading.svg";
import { SvgHandler } from "../../../../svg-handler/svg-handler";
import "./loader.m.css";

export const Loader = ({ data, subscriptionConfig }) => {
  const [displayMessage, setMessage] = useState(false);
  const { loaderMessage } = subscriptionConfig;
  const emptyString = "<p><br></p>";
  const updatedLoaderMessage = loaderMessage === emptyString ? "" : loaderMessage;
  useEffect(() => {
    setTimeout(() => {
      if (!data?.length) {
        setMessage(true);
      }
    }, 15000);

    if (data.length) {
      setMessage(false);
    }
  }, [data]);

  return (
    <div styleName="loader-wrapper">
      <div styleName="loader">
        <SvgHandler xlinkHref={loadingIcon} />
        <p styleName="title">Loading Plans</p>
        {displayMessage &&
          (updatedLoaderMessage ? (
            <p styleName="message" dangerouslySetInnerHTML={{ __html: updatedLoaderMessage }} />
          ) : (
            <p styleName="message">
              Oops, it seems plans are taking longer than expected to load. Thank you for your patience!
            </p>
          ))}
      </div>
    </div>
  );
};
